import styled from 'styled-components'

export const Wrapper = styled.div`
  font-family: var(--typography-normal);
  z-index: 1;
  position: relative;
  user-select: none;
  box-sizing: border-box;

  * {
    box-sizing: inherit;
  }
`

export const Anchor = styled.div`
  height: 32px;
  min-width: 136px;
  border: 1px solid #e7e7ea;
  position: relative;
  z-index: 2;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 7px 11px;
  background: #fff;
  font: var(--typography-12-16-regular);
  color: #121432;
  cursor: pointer;

  :hover {
    box-shadow: 0 3px 5px rgba(95, 99, 104, 0.05),
      0 10px 10px rgba(95, 99, 104, 0.05), 0 1px 18px rgba(95, 99, 104, 0.05);
  }
`

export const Label = styled.div`
  margin-right: 8px;
`

export const List = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 16px 0 8px;
  background: #fff;
  border: 0.5px solid #e7e7ea;
  box-shadow: 0 3px 5px rgba(95, 99, 104, 0.05),
    0 10px 10px rgba(95, 99, 104, 0.05), 0 1px 18px rgba(95, 99, 104, 0.05);
  border-radius: 0 0 8px 8px;
  position: absolute;
  left: 0;
  right: 0;
  top: 24px;
  z-index: 1;
`

export const FlagWrapper = styled.div`
  display: flex;
  margin-right: 16px;
`

export const Item = styled.div`
  cursor: pointer;
  border-left: 2px solid var(--color-white);
  padding: 7px 10px 7px 13px;
  min-height: 40px;
  color: #121432;
  font: var(--typography-12-16-regular);
  display: flex;
  align-items: center;
  flex-shrink: 0;

  :hover {
    background: #f9f9f9;
    border-left-color: var(--color-velvet);
  }
`

export const ItemAdd = styled(Item)`
  color: var(--color-sw-10);
`
